module.exports = __webpack_public_path__ + "static/592-f65ceb9da1a2ef3dd666ad5f62c7e833.png";